import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","z-index":"1060"}
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-2",
  style: {"padding":"0px"}
}
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = { class: "sub-title" }
const _hoisted_9 = {
  key: 0,
  class: "call-details"
}
const _hoisted_10 = { class: "detail-text" }
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "col-6" }

import { Icon } from "@iconify/vue";
import { Button } from "@/components/ui";
import { useRouter } from "vue-router";
import { CONTACT_OVERVIEW_ROUTE } from "@/router/routes";

interface Props {
  show: boolean;
  contactId: string;
  contactName: string;
  callLogId: string;
  duration: number | null;
  isLoading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallBucketPromptModal',
  props: {
    show: { type: Boolean },
    contactId: {},
    contactName: {},
    callLogId: {},
    duration: {},
    isLoading: { type: Boolean, default: false }
  },
  emits: ["close", "create"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();

const closeModal = () => {
  emit("close");
};

const createTask = () => {
  emit("create", props.callLogId, props.contactId);
  // Navigate to contact overview where user can create a bucket
  // The contact overview page can check for callLogId in query to pre-fill bucket creation
  router.push({
    name: CONTACT_OVERVIEW_ROUTE,
    params: { id: props.contactId },
    query: {
      createBucket: "true",
      callLogId: props.callLogId,
      taskType: "call",
    },
  });
  closeModal();
};

const formatDuration = (seconds: number | null): string => {
  if (!seconds) return "N/A";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
};

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Icon), {
                onClick: closeModal,
                icon: "mdi:close",
                class: "close-icon",
                width: "20",
                height: "20"
              }),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:phone-in-talk",
                    class: "col-12 modal-icon",
                    width: "48",
                    height: "48"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "title" }, "Live Conversation Detected", -1)),
                  _createElementVNode("small", _hoisted_8, [
                    _cache[0] || (_cache[0] = _createTextVNode(" You had a live conversation with ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(__props.contactName), 1),
                    _cache[1] || (_cache[1] = _createTextVNode(". Would you like to create a follow-up task? ", -1))
                  ]),
                  (__props.duration)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("small", _hoisted_10, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:clock-outline",
                            width: "14",
                            height: "14"
                          }),
                          _createTextVNode(" Duration: " + _toDisplayString(formatDuration(__props.duration)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Button), {
                    variant: "secondary",
                    size: "md",
                    block: "",
                    disabled: __props.isLoading,
                    onClick: closeModal
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Dismiss ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(Button), {
                    variant: "primary",
                    size: "md",
                    block: "",
                    loading: __props.isLoading,
                    disabled: __props.isLoading,
                    onClick: createTask
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Create Task ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})